import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type GeneralState = {
  loading: boolean;
  isLoading?: boolean;
  updateListing?: boolean;
  searchValue?: any;
};

export const initialAuthState: GeneralState = {
  loading: false,
  isLoading: false,
  updateListing: false,
  searchValue: "",
};

const slice = createSlice({
  name: "General",
  initialState: initialAuthState,
  reducers: {
    handleLoading: (state: any, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    handleIsLoading: (state: any, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    handleListing: (state: any, action: PayloadAction<boolean>) => {
      state.updateListing = action.payload;
    },
    handleSearching: (state: any, action: PayloadAction<any>) => {
      state.searchValue = action.payload;
    },
  },
});

const { reducer } = slice;

export const {
  handleLoading,
  handleIsLoading,
  handleListing,
  handleSearching,
} = slice.actions;

export default reducer;
